













































import { Component, Vue } from "vue-property-decorator";
import HeaderComponent from "@/components/layout/HeaderComponent.vue";
import MainComponent from "@/components/layout/MainComponent.vue";
import SidebarComponent from "@/components/layout/SidebarComponent.vue";
import ContentComponent from "@/components/layout/ContentComponent.vue";
import SidebarContentHeaderComponent, {
  GetStoreSensorsResponse
} from "@/components/layout/SidebarContentHeaderComponent.vue";
import GraphAreaComponent from "@/components/pages/temp_graphs/GraphAreaComponent.vue";
import CategorySideMenuComponent, {
  CategorySideMenuSensor,
  CategorySideMenuIcon
} from "@/components/layout/CategorySideMenuComponent.vue";
import ButtonComponent from "@/components/common/parts/ButtonComponent.vue";
import FooterComponent from "@/components/layout/FooterComponent.vue";

import { Sensor, SensorGraphData } from "@/typescript/models/sensor/types";
import { TempGraphsData } from "@/typescript/pages/temp_graphs/types";
import { ApexOptions } from "apexcharts";
import { storeMenus } from "@/config/store_menus";
import { getStoreSensorsApi } from "@/typescript/api_client/emesh_api/stores/store_sensors_api";
import { convertNullObject } from "@/typescript/lib/common/convert_null_object";
import { COLORS } from "../config/graph";
import { GetStoreSensorsResponseSensor } from "@/typescript/api_client/emesh_api/stores/types";
import { DisplayTime } from "@/typescript/packages/timepicker/types";
import { fillZero } from "@/typescript/lib/common/fill_zero";

export {
  Sensor,
  SensorGraphData,
  TempGraphsData,
  ApexOptions,
  DisplayTime,
  GetStoreSensorsResponse,
  GetStoreSensorsResponseSensor,
  CategorySideMenuSensor,
  CategorySideMenuIcon
};

@Component({
  components: {
    HeaderComponent,
    MainComponent,
    SidebarComponent,
    ContentComponent,
    SidebarContentHeaderComponent,
    GraphAreaComponent,
    CategorySideMenuComponent,
    ButtonComponent,
    FooterComponent
  }
})
export default class TempGraphsPage extends Vue {
  graphs: number[] = [0];
  storeName: string = "";
  storeSensors: GetStoreSensorsResponseSensor[] = [];
  categorySideMenuSensors: CategorySideMenuSensor[] = [];
  sensorIcons: CategorySideMenuIcon[] = [];
  graphComponentBaseRef: string = "graph_area_component";

  created() {
    this.$store.commit("setActiveId", {
      activeId: storeMenus().find(m => m.pageName === "TempGraphsPage")?.id
    });
    this.setApiData();
  }

  async setApiData() {
    const storeSensors = await getStoreSensorsApi(this.$route.params.store_id);
    this.storeName = storeSensors.store_name;
    this.storeSensors = storeSensors.sensors;
    const iconKinds = this.storeSensors
      .map(ss => {
        return {
          iconKind: ss.icon_kind,
          status: "off"
        };
      })
      .filter((icon, index, self) => {
        return (
          self.findIndex(icon2 => {
            return icon.iconKind === icon2.iconKind;
          }) === index
        );
      }) as CategorySideMenuIcon[];

    this.sensorIcons = iconKinds.map(i => {
      const sensors = this.storeSensors.filter(
        (e: any) => e.icon_kind === i.iconKind
      );
      return {
        ...i,
        sensors: sensors
      };
    }) as CategorySideMenuIcon[];
    this.categorySideMenuSensors = this.storeSensors
      .map((ss, i) => {
        const res = {
          equipmentId: ss.equipment_id,
          equipmentName: ss.equipment_name,
          iconKind: ss.icon_kind,
          isChecked: false,
          color: COLORS[i],
          locationNo:
            ss.location_no === null ? "00" : fillZero(ss.location_no, 2),
          lowerLimit: ss.lower_limit === null ? "--" : ss.lower_limit
        };
        return convertNullObject(res, "--", ["equipmentName"]);
      })
      // 2021.08.24 センサが下限閾値順になるよう修正
      //.sort((a, b) => Number(a.locationNo) - Number(b.locationNo));
      .sort((a, b) => Number(a.lowerLimit) - Number(b.lowerLimit));

    this.$nextTick(() => {
      if (Object.keys(this.$route.query).length > 0) {
        const ele = document.getElementById(
          `category_side_menu_component_${this.$route.query["equipment_id"]}`
        ) as HTMLInputElement;
        ele.click();
      }
    });
  }

  onClickSensorIcon(icon: CategorySideMenuIcon) {
    icon.sensors?.forEach(s => {
      const ele = document.getElementById(
        `category_side_menu_component_${s.equipment_id}`
      ) as HTMLInputElement;
      ele.checked = icon.status === "off";
      this.checkCategorySensor({
        equipmentId: s.equipment_id,
        equipmentName: s.equipment_name,
        iconKind: s.icon_kind,
        locationNo: s.location_no === null ? "00" : fillZero(s.location_no, 2),
        isChecked: icon.status === "off"
      });
    });
    this.sensorIcons[
      this.sensorIcons.findIndex(e => e.iconKind === icon.iconKind)
    ].status = icon.status === "off" ? "on" : "off";
    this.graphs.forEach(v => {
      const graphComponent = this.$refs[
        `${this.graphComponentBaseRef}_${v}`
      ] as GraphAreaComponent;
      graphComponent[0].updateGraph();
    });
  }

  checkCategorySensor(sensor: CategorySideMenuSensor) {
    this.categorySideMenuSensors[
      this.categorySideMenuSensors.findIndex(
        csms => csms.equipmentId === sensor.equipmentId
      )
    ].isChecked = sensor.isChecked;
  }

  onCheckCategorySensor(sensor: CategorySideMenuSensor) {
    this.$store.commit("setIsGraphLoading", {
      isGraphLoading: true
    });
    this.checkCategorySensor(sensor);

    this.graphs.forEach(v => {
      const graphComponent = this.$refs[
        `${this.graphComponentBaseRef}_${v}`
      ] as GraphAreaComponent;
      graphComponent[0].updateGraph();
    });

    if (
      this.categorySideMenuSensors.every(ccs => {
        return !ccs.isChecked;
      })
    ) {
      setTimeout(() => {
        this.$store.commit("setIsGraphLoading", {
          isGraphLoading: false
        });
      }, 100);
    }
  }

  addGraph() {
    // グラフは 2 つまでしか追加することはできない仕様
    if (this.graphs.length >= 2) return;
    this.graphs.push(this.graphs[this.graphs.length - 1] + 1);
  }

  removeGraph(index: number) {
    this.graphs.splice(index, 1);
  }
}
